import { v } from '@/lib/validator';

export default v.object().shape({
  email: v.string().required('Email é obrigatório'),
  name: v.string().required('First name é obrigatório'),
  password: v.string().required('Senha é obrigatória'),
  confirmPassword: v.string().oneOf([v.ref('password'), null], 'Senhas tem que ser iguais'),
});
